import React, { Component } from 'react'

// Graphql
import { graphql } from 'react-apollo'
import gql from 'graphql-tag'
import axios from 'axios';
import moment from 'moment';

// Material UI Imports
import List from '@material-ui/core/List';
import ExpansionPanel from '@material-ui/core/ExpansionPanel';
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import Divider from '@material-ui/core/Divider';
import Button from '@material-ui/core/Button';




// Material Icons Imports
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';

// Assets imports
import '../styles/UserDetail.css';

// Components Imports
import NormalField from './innerComponents/NormalField';
import Project from './innerComponents/Project';
import Device from "./innerComponents/Device";
import Certificate from './innerComponents/Certificate';
import CustomLoader from './innerComponents/CustomLoader';



class UserDetail extends Component {
  state = {
    refetched: false,
    showButton: false,
  }

  _getProjectList(currrent_user) {
    return currrent_user.projects !== null && currrent_user.projects.length > 0 ?
      currrent_user.projects.map((project, id) =>
        <Project project={project} key={id} />
      ) : <span>There are no Projects yet!</span>;
  }

  _getDeviceList(currrent_user) {
    return currrent_user.devices !== null && currrent_user.devices.length > 0 ?
      currrent_user.devices.map((device, id) =>
        <Device device={device} key={id} />
      ) : <span>There are no Devices yet!</span>;
  }

  _getCertificateList(currrent_user) {
    return currrent_user.certificates !== null && currrent_user.certificates.length > 0 ?
      currrent_user.certificates.map((certificate, id) => {
        certificate.userId = this.props.selectedId
        certificate.userName = currrent_user.name
        return <Certificate handler={this._handleArchiveCertificate.bind(this)} certificate={certificate} key={id} />
      }
      ) : <span>There are no Certificates yet!</span>;
  }

  _getExpiredCertificateList(currrent_user) {
    return currrent_user.expiredCertificates !== null && currrent_user.expiredCertificates.length > 0 ?
      currrent_user.expiredCertificates.map((certificate, id) => {
        certificate.userId = this.props.selectedId
        certificate.userName = currrent_user.name
        return <Certificate handler={this._handleArchiveCertificate.bind(this)} certificate={certificate} key={id} />
      }
      ) : <span>There are no Certificates yet!</span>;
  }

  _getArchivedCertificateList(currrent_user) {
    return currrent_user.archivedCertificates !== null && currrent_user.archivedCertificates.length > 0 ?
      currrent_user.archivedCertificates.map((certificate, id) => {
        certificate.userId = this.props.selectedId
        certificate.userName = currrent_user.name
        return <Certificate handler={this._handleArchiveCertificate.bind(this)} certificate={certificate} key={id} />
      }
      ) : <span>There are no Certificates yet!</span>;
  }

  _handleClickCreateCertificate() {
    const userId = this.props.selectedId;
    this.props.history.push(`/certificates/new/user/${userId}`);
  }

  _handleClickDownloadAllCertificates(currrent_user){
    const userId = this.props.selectedId
    const zipUrl = process.env.REACT_APP_BACKEND_BASE_URL + '/users/' + userId + '/certificates/'
    console.log(zipUrl)
    axios.get(zipUrl,
      {
        responseType: 'arraybuffer',
        headers: {
          'Authorization': localStorage.getItem("token")
        }
      }).then((response) => {
        let type = 'application/zip';
        let fileName = currrent_user.name + '_' + currrent_user.role + '_active_certs_' + moment(Date(Date.now())).format('YYYY-MM-DD_HH-mm-ss')
        const url = window.URL.createObjectURL(new Blob([response.data],
          { type: type }));
        const link = document.createElement('a');
        link.href = url;
        const linkDownload = document.createElement('a');
        linkDownload.href = url;
        linkDownload.setAttribute('download', fileName + ".zip");
        link.target = '_blank';
        document.body.appendChild(link);
        document.body.appendChild(linkDownload);
        this.setState({
          url: url,
          download: linkDownload,
          show: link
        })
        this.state['download'].click()
      }).catch((error) => console.log(error));
  }

  _handleArchiveCertificate(){
    console.log('up');
    this.props.user_query.refetch();
  }

  componentDidMount(){
    if (this.props.refetch && !this.state.refetched) {
      this.props.user_query.refetch().then(()=>{
        this.setState({
          refetched: true
        })
      }

      ).catch((e)=>console.log(e))
    }
  }

  render() {



    // Check if the query response is being loaded
    if (this.props.user_query && this.props.user_query.loading) {
      return <CustomLoader label={'Loading'}/>
    }

    // Check if there were errrors
    if (this.props.user_query && this.props.user_query.error) {
      console.log(this.props.user_query.error)
      return <div>Error</div>
    }

    // Get the data to render it
    // console.log("Name: " + this.props.user_query.user.name);
    const currrent_user = this.props.user_query.user;

    const { showButton } = this.state;

    return (
      <div className="UserDetail">
        <div>
          <NormalField
            label="Company"
            input={currrent_user.company} />

          <NormalField
            label="Role"
            input={currrent_user.role} />
        </div>
        <div>
          <NormalField
            label="Job Title"
            input={currrent_user.jobTitle} />

          <NormalField
            label="Region"
            input={currrent_user.region.name} />
        </div>
        <div>
          <NormalField
            label="Email"
            input={currrent_user.email} />
        </div>

        <ExpansionPanel style={{ marginTop: 16 }}>
          <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
            Projects
          </ExpansionPanelSummary>
          <ExpansionPanelDetails>
            <div>
              <List>
                {this._getProjectList(currrent_user)}
              </List>
            </div>
          </ExpansionPanelDetails>
        </ExpansionPanel>
        <ExpansionPanel style={{ marginTop: 16 }}>
          <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
            Devices
          </ExpansionPanelSummary>
          <ExpansionPanelDetails>
            <div>
              <List>
                {this._getDeviceList(currrent_user)}
              </List>
            </div>
          </ExpansionPanelDetails>
        </ExpansionPanel>
        <ExpansionPanel style={{ marginTop: 16 }} onChange={(obj, exp) => this.setState({ showButton: exp })}>
          <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
            Active Certificates
            {
              showButton && <Button
              style={
                {
                  marginLeft: 'auto',
                }}
                color="primary"
                onClick={this._handleClickCreateCertificate.bind(this)}
              >
                New
              </Button>
            }
            {
              showButton && <Button
              style={
                {
                  marginRight: 20
                }}
                color="primary"
                onClick={this._handleClickDownloadAllCertificates.bind(this, currrent_user)}
              >
                Download all
              </Button>
            }
          </ExpansionPanelSummary>
          <ExpansionPanelDetails>
            <div style={{ width: '100%' }}>
              <List>
                {this._getCertificateList(currrent_user)}
              </List>
            </div>
          </ExpansionPanelDetails>
          <Divider />
        </ExpansionPanel>
        <ExpansionPanel style={{ marginTop: 16 }}>
          <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
            Expired Certificates
          </ExpansionPanelSummary>
          <ExpansionPanelDetails>
            <div style={{ width: '100%' }}>
              <List>
                {this._getExpiredCertificateList(currrent_user)}
              </List>
            </div>
          </ExpansionPanelDetails>
          <Divider />
        </ExpansionPanel>
        <ExpansionPanel style={{ marginTop: 16 }}>
          <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
            Archived Certificates
          </ExpansionPanelSummary>
          <ExpansionPanelDetails>
            <div style={{ width: '100%' }}>
              <List>
                {this._getArchivedCertificateList(currrent_user)}
              </List>
            </div>
          </ExpansionPanelDetails>
          <Divider />
        </ExpansionPanel>
      </div>
    )
  }
}


// GraphQL Query
const USER_QUERY = gql`
  query user_query($selectedId: ID!,$expiryDate:Date!){
    user(id: $selectedId){
      name
      email
      role
      company
      jobTitle
      region{
        id
        name
      }
      devices{
        identifier
        type
      }
      projects{
        id
        name
        number
      }
      certificates(filters:[{field:"expiry_date_gt", operand:$expiryDate, connector: AND},
      {field:"marked_as_deleted_eq", operand:"false"}
      ]){
        id
        expiryDate
        markedAsDeleted
        baseFileName
        certification{
          id
          name
        }
      }
      expiredCertificates: certificates(filters:[{field:"expiry_date_lt", operand:$expiryDate, connector: AND},
    {field:"marked_as_deleted_eq", operand:"false"}
     ]){
      id
      expiryDate
      markedAsDeleted
      baseFileName
      certification{
        id
        name
      }
      }
      archivedCertificates: certificates(filters:[
    {field:"marked_as_deleted_eq", operand:"true"}
     ]){
      id
      expiryDate
      markedAsDeleted
      baseFileName
      certification{
        id
        name
      }
      }

    }
  }
`;

export default graphql(USER_QUERY, { name: "user_query",
  options: ({ selectedId,expiryDate }) => ({ variables: { selectedId, expiryDate } }),
})(UserDetail);


// WEBPACK FOOTER //
// src/components/UserDetail.js